import Calendar from './calendar';
import './calendar.scss';

export default Calendar;
